import { axiosWithAuth } from "@/lib/AxiosClient";
import { Feature } from "@/lib/models"

export interface AttachmentDetails {
  id: string
  filename: string
  url: string
  size: number
}

export interface NewFeatureRequest extends Feature {
  siteId: string
}

export class FeatureService {
  private static readonly BASE_PATH = "/api/features"
  private static instance = axiosWithAuth;

  static async createFeature(feature: NewFeatureRequest): Promise<Feature> {
    const response = await this.instance.post<Feature>(`${this.BASE_PATH}`, feature);
    return response.data;
  }

  static async updateFeature(featureId: string, feature: Feature): Promise<Feature> {
    const response = await this.instance.put<Feature>(`${this.BASE_PATH}/${featureId}`, feature)
    return response.data
  }

  static async delete(featureId: string): Promise<void> {
    await this.instance.delete<void>(`${this.BASE_PATH}/${featureId}`)
  }

  static async getByFeatureIds(featureIds: string[]): Promise<Feature[]> {
    const response = await this.instance.post<Feature[]>(`${this.BASE_PATH}/id`, featureIds)
    return response.data
  }

  static async getById(featureId: string): Promise<Feature> {
    const response = await this.instance.get<Feature>(`${this.BASE_PATH}/${featureId}`)
    return response.data
  }

  static async getBySiteId(siteId: string): Promise<Feature[]> {
    const response = await this.instance.get<Feature[]>(`${this.BASE_PATH}/site/${siteId}`)
    return response.data
  }

  static async getByAreaId(areaId: string): Promise<Feature[]> {
    const response = await this.instance.get<Feature[]>(`${this.BASE_PATH}/area/${areaId}`)
    return response.data
  }

  static async getByFeatureTypeId(featureTypeId: string): Promise<Feature[]> {
    const response = await this.instance.get<Feature[]>(`${this.BASE_PATH}/featuretypes/${featureTypeId}`)
    return response.data
  }
}
